var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bread-crumbs"},[_c('app-bread-crumbs',{staticClass:"capitalize",attrs:{"routes":[
      { name: 'login', title: 'Connexion / Inscription' },
      { name: 'myAccountPage', title: 'Mon compte' },
      { name: 'myAccountEditPage', title: 'Modifier mon compte' },
    ]}}),_c('b-row',[_c('b-col',[_c('h1',{staticClass:"uppercase page-title"},[_vm._v("Modifier mon compte")]),_c('form-edit-account')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }